<template>
    <div class="card" :style="stylealpha">
        <div class="card-content" :style="style">
            <span class="card-title">{{ item.name }}</span>
            <span class="card-summary" v-if="item.auto_validation !== true">{{
                item.vigilance.desc_fr
            }}</span>
            <span class="card-summary" v-if="item.auto_validation == true"
                >{{ item.vigilance.desc_fr }} <b>avec validation automatique</b></span
            >
            <div class="card-actions">
                <font-awesome-icon
                    title="Modifier"
                    icon="pencil-alt"
                    class="card-actions--icon"
                    @click="handleEdit(item.id)"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: { type: Object, required: true },
        handleEdit: { type: Function },
    },
    computed: {
        style() {
            if (this.item.auto_validation) {
                return `border-radius:15px;border-left:10px solid greenyellow;border-right:10px solid greenyellow;width:100%;`;
            } else {
                return `border-radius:15px;border-left:10px solid ${
                    this.item.vigilance.color
                };border-right:10px solid ${this.item.vigilance.color};width:100%;`;
            }
        },
        stylealpha() {
            return `background: ${this.item.vigilance.color}1A;`;
        },
    },
};
</script>

<style lang="scss"></style>
